// Palette unique pour l'affichage des statuts client dans toute la partie
// "Projections de Contrats". Les statuts sont uniquement numériques
// (Status.Number côté back: -1/0 = hors programme, puis 1 à 4) — il n'y a
// pas de nom de statut (pas de "Bronze/Silver/Gold/Platinium"). Un même
// statut doit toujours s'afficher avec la même couleur, quel que soit
// l'endroit de la partie Projections.
const STATUS_COLOR_BY_NUMBER = {
  "-1": "#9E9E9E", // Hors programme
  0: "#9E9E9E", // Hors programme
  1: "#CD7F32", // Statut 1
  2: "#78909C", // Statut 2 (assombri par rapport au gris clair d'origine pour rester lisible)
  3: "#FFD700", // Statut 3
  4: "#5C6B73", // Statut 4 (assombri par rapport au blanc cassé d'origine pour rester lisible)
};

/**
 * Retourne la couleur associée à un identifiant de statut numérique
 * (-1, 0 à 4, en number ou en string).
 */
export function getStatusColor(status) {
  if (status === undefined || status === null) {
    return STATUS_COLOR_BY_NUMBER[0];
  }
  return STATUS_COLOR_BY_NUMBER[status] ?? STATUS_COLOR_BY_NUMBER[0];
}
